export default "__VITE_ASSET__08e7ac4a__"